<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form ref="recensementForm" @submit="addRecensement" :validation-schema="recensementSchema">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Nom <span class="text-danger">*</span>
              </label>
              <Field name="nom" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrez le nom" />
              <ErrorMessage name="nom" class="text-danger" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Prénom <span class="text-danger">*</span>
              </label>
              <Field name="prenom" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrez le prénom" />
              <ErrorMessage name="prenom" class="text-danger" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date de naissance <span class="text-danger">*</span>
              </label>
              <Field name="dateNaissance" type="date" class="form-control shadow-none fs-md-15 text-black" />
              <ErrorMessage name="dateNaissance" class="text-danger" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Lieu de naissance <span class="text-danger">*</span>
              </label>
              <Field name="LieuNaissance" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrez le lieu de naissance" />
              <ErrorMessage name="LieuNaissance" class="text-danger" />
            </div>
          </div>

          <!-- Contact : téléphone avec drapeaux + préfixes pays -->
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Contact <span class="text-danger">*</span>
              </label>
              <Field name="contact" v-slot="{ field }">
                <vue-tel-input
                  placeholder="Entrez le numéro de téléphone"
                  v-model="field.value"
                  v-bind="field"
                  defaultCountry="BJ"
                  mode="international"
                  @validate="validate"
                  class="shadow-none fs-md-15 text-black py-2">
                </vue-tel-input>
              </Field>
              <div v-if="!validPhone" class="text-danger">Veuillez entrer un numéro correct</div>
              <ErrorMessage name="contact" class="text-danger" />
            </div>
          </div>

          <!-- Pays d'origine : liste des pays -->
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Pays d'origine <span class="text-danger">*</span>
              </label>
              <Field name="paysOrigine" v-slot="{ field }">
                <Multiselect
                  :options="countries"
                  :searchable="true"
                  track-by="label"
                  label="label"
                  v-model="field.value"
                  v-bind="field"
                  placeholder="Sélectionnez le pays d'origine" />
              </Field>
              <ErrorMessage name="paysOrigine" class="text-danger" />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Pays de résidence <span class="text-danger">*</span>
              </label>
              <Field name="PaysResidence" v-slot="{ field }">
                <Multiselect
                  :options="countries"
                  :searchable="true"
                  track-by="label"
                  label="label"
                  v-model="field.value"
                  v-bind="field"
                  placeholder="Sélectionnez le pays de résidence" />
              </Field>
              <ErrorMessage name="PaysResidence" class="text-danger" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Ville de résidence <span class="text-danger">*</span>
              </label>
              <Field name="villeResidence" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrez la ville de résidence" />
              <ErrorMessage name="villeResidence" class="text-danger" />
            </div>
          </div>

           <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Secteurs d'activité
              </label>
              <Field name="secteuractivites" v-slot="{ field }">
                <Multiselect
                  :options="secteurOptions"
                  :searchable="true"
                  mode="tags"
                  track-by="label"
                  label="label"
                  v-model="field.value"
                  v-bind="field"
                  placeholder="Sélectionnez un ou plusieurs secteurs d'activité"
                />
              </Field>
              <ErrorMessage name="secteuractivites" class="text-danger" />
            </div>
          </div>
           <!-- Description -->
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Description
              </label>
              <Field name="description" as="textarea" rows="3" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Décrivez brièvement ce que vous voulez faire" />
              <ErrorMessage name="description" class="text-danger" />
            </div>
          </div>


          <!-- Cases à cocher : l'un ou l'autre, pas les deux -->
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="form-check">
                <Field name="jeSuisDadjohoun" type="checkbox" :value="true" class="form-check-input"
                  id="jeSuisDadjohoun" @change="onToggle('dadjohoun')" />
                <label class="form-check-label text-black fw-semibold" for="jeSuisDadjohoun">
                  Je suis d'Adjohoun
                </label>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="form-check">
                <Field name="jeSuisPartisan" type="checkbox" :value="true" class="form-check-input"
                  id="jeSuisPartisan" @change="onToggle('partisan')" />
                <label class="form-check-label text-black fw-semibold" for="jeSuisPartisan">
                  Je suis partisan
                </label>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <ErrorMessage name="jeSuisDadjohoun" class="text-danger" />
          </div>

          <!-- Multi-select des secteurs d'activité -->
         
          <div class="col-md-12">
            <div class="d-flex align-items-center">
              <button class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                type="submit" :disabled="!validPhone">
                Ajouter
              </button>
              <router-link to="/liste-recensements"
                class="btn btn-danger transition border-0 lh-1 fw-medium">
                <i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                Annuler
              </router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import { useRouter } from "vue-router";
import Swal from "sweetalert2";
import Multiselect from "@vueform/multiselect";
import { VueTelInput } from "vue3-tel-input";
import "vue3-tel-input/dist/vue3-tel-input.css";
import ApiService from "../../services/ApiService";
import { error } from "../../utils/utils";
import { countries } from "@/utils/countries";

export default defineComponent({
  name: "AddRecensement",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
    VueTelInput,
  },
  setup: () => {
    const recensementSchema = Yup.object().shape({
      nom: Yup.string().required("Le nom est obligatoire"),
      prenom: Yup.string().required("Le prénom est obligatoire"),
      dateNaissance: Yup.string().required("La date de naissance est obligatoire"),
      LieuNaissance: Yup.string().required("Le lieu de naissance est obligatoire"),
      contact: Yup.string().required("Le contact est obligatoire"),
      paysOrigine: Yup.string().required("Le pays d'origine est obligatoire"),
      PaysResidence: Yup.string().required("Le pays de résidence est obligatoire"),
      villeResidence: Yup.string().required("La ville de résidence est obligatoire"),
      jeSuisDadjohoun: Yup.boolean().test(
        "un-ou-l-autre",
        "Veuillez sélectionner l'un ou l'autre",
        function () {
          return this.parent.jeSuisDadjohoun === true || this.parent.jeSuisPartisan === true;
        }
      ),
    });

    const recensementForm = ref<any>(null);
    const router = useRouter();
    const secteurOptions = ref<{ value: number; label: string }[]>([]);
    const validPhone = ref<boolean>(false);

    // Validation du numéro de téléphone (vue3-tel-input)
    function validate(phoneObject: any) {
      validPhone.value = phoneObject.valid;
    }

    // Cases à cocher exclusives : cocher l'une décoche l'autre (l'un ou l'autre, pas les deux)
    function onToggle(choix: string) {
      if (choix === "dadjohoun") {
        recensementForm.value?.setFieldValue("jeSuisDadjohoun", true);
        recensementForm.value?.setFieldValue("jeSuisPartisan", false);
      } else {
        recensementForm.value?.setFieldValue("jeSuisPartisan", true);
        recensementForm.value?.setFieldValue("jeSuisDadjohoun", false);
      }
    }

    // Chargement du catalogue des secteurs d'activité pour le multi-select
    const fetchSecteurs = async () => {
      try {
        const response = await ApiService.get("/secteuractivites");
        const secteurs = response.data.data.data;
        secteurOptions.value = secteurs.map((s: any) => ({
          value: s.id,
          label: s.libelle,
        }));
      } catch (err: any) {
        error("Impossible de charger les secteurs d'activité");
      }
    };

    const addRecensement = async (values: any, { resetForm }) => {
      try {
        const response = await ApiService.post("/recensement", values);
        Swal.fire({
          title: "Recensement créé avec succès",
          icon: "success",
          draggable: true,
          confirmButtonText: "OK",
          timer: 1500,
        }).then(() => {
          resetForm();
          router.push("/liste-recensements");
        });
        console.log("Recensement ajouté avec succès:", response.data);
      } catch (err: any) {
        console.error("Erreur lors de l'envoi :", err);
        Swal.fire({
          title: "Erreur lors de l'ajout du recensement",
          text: err.response?.data?.message || "Une erreur est survenue",
          icon: "error",
          draggable: true,
        });
      }
    };

    onMounted(() => {
      fetchSecteurs();
    });

    return {
      addRecensement,
      recensementSchema,
      recensementForm,
      secteurOptions,
      validPhone,
      validate,
      onToggle,
      countries,
    };
  },
});
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
